// Dérivation « zone » d'un lieu de mission : secteur géographique si le code
// postal est mappé dans la config (/configuration → Secteurs), sinon la
// meilleure info disponible. Partagé entre le filtre secteur du dispatch
// (À traiter) et le bandeau Camions.

// Table code postal → nom de secteur, à reconstruire quand la config change
// (les codes viennent de state.autreInfo.secteurs : {id, nom, codes:[{code}]}).
export function buildSecteurParCode(secteurs) {
	const map = {}
	;(secteurs || []).forEach((s) =>
		(s.codes || []).forEach((c) => {
			const code = c && c.code ? String(c.code).trim() : ""
			if (code) map[code] = s.nom
		}),
	)
	return map
}

// Secteur exact d'un code postal, ou null (contrat du filtre « Inconnu »).
export function getSecteurParCode(secteurParCode, codePostal) {
	const cp = codePostal ? String(codePostal).trim() : ""
	return (cp && secteurParCode[cp]) || null
}

const NPA_RE = /\b\d{4}\b/

// Libellé de zone d'un PointInteret sérialisé (po) + textes libres _0/_1/_2
// (import e-mail). Chaîne de fallback validée avec Jordan (07.2026) :
// secteur mappé → NPA + localité → coordonnées GPS → label POI → localité/rue
// → texte brut (avec tentative NPA regex) → null (l'appelant n'affiche rien).
export function getZoneLabel(secteurParCode, po, textes = []) {
	const a = (po && po.adresse) || {}
	const extra = a.extra_data || {}

	const secteur = getSecteurParCode(secteurParCode, a.code_postal)
	if (secteur) return secteur
	if (a.code_postal)
		return [String(a.code_postal).trim(), a.localite].filter(Boolean).join(" ")
	if (extra.latitude && extra.longitude) return "coordonnées GPS"
	if (po && po.label) return po.label
	if (a.localite) return a.localite
	if (a.rue) return [a.rue, a.numero].filter(Boolean).join(" ")

	const fb = (textes || []).filter(Boolean)
	if (fb.length > 0) {
		const m = fb.join(" ").match(NPA_RE)
		if (m) {
			const secteurTexte = getSecteurParCode(secteurParCode, m[0])
			if (secteurTexte) return secteurTexte
		}
		return fb[0].length > 28 ? `${fb[0].slice(0, 28)}…` : fb[0]
	}
	return null
}
